import { Component, Inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { CommonModule, DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-shell',
  standalone: true,
  imports: [CommonModule, RouterOutlet],
  templateUrl: './shell.component.html',
  styleUrl: './shell.component.css'
})
export class ShellComponent {

  constructor(
    public auth: AuthService,
    @Inject(DOCUMENT) private document: Document
  ) {}

  logout() {
    this.auth.logout({ logoutParams: { returnTo: this.document.location.origin + '/login' } });
  }
}
